export default __webpack_public_path__ + "static/media/Sweet-2.edc7a5c1.jpg";